export function getEbayUrl(ebayListingId: string): string {
  return `https://www.ebay.com/itm/${ebayListingId}`;
}

export function getGtsStoreUrl(title: string, gtsStoreId: number): string {
  return `https://www.greenteksolutionsllc.com/store/product/${title}/${gtsStoreId}`;
}
